/**
 * Workers Module Configuration
 *
 * Provides the job monitoring dashboard. This module does NOT appear
 * in the sidebar — it is linked from the Settings overview and nav.
 */

import type { AppModule } from '@/types/architecture'
import routes from './routes'

const workersModule: AppModule = {
    id: 'workers',

    navigation: {
        label: 'Workers',
        icon: 'activity',
        path: '/workers',
        order: 95, // near settings
        moduleKey: 'settings.workers',
        showInSidebar: false, // hidden — accessed via Settings
        pages: [
            {
                label: 'Jobs',
                path: '/workers',
                icon: 'activity',
            },
        ],
    },

    routes,
}

export default workersModule
